import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Link, Text } from '@chakra-ui/react'

import PendingRenewalsTable from './RenewalsTable'
import DoNotRenewSetPanel from './DoNotRenewSetPanel'
import { PendingRenewalInfoFragment } from 'graphql/generated'

const RenewalsPanelContent: React.FC<
  React.PropsWithChildren<{ rental: PendingRenewalInfoFragment }>
> = ({ rental }) => {
  const renewals = (rental?.rahWithRenewal ?? []).map((rah) => rah.renewals).flat()
  const isDoNotRenewSet = !!rental?.do_not_renew_selected_at

  if (!renewals.length) {
    return (
      <>
        {isDoNotRenewSet && <DoNotRenewSetPanel />}
        {!isDoNotRenewSet && (
          <Text as='i'>
            This rental has no renewals to show. You can issue a custom renewal here or enter a
            renewal offer in the{'  '}
            <Link as={RouterLink} color='teal' to='/properties/renewal-manager'>
              Renewal Manager.
            </Link>
          </Text>
        )}
      </>
    )
  }

  return (
    <>
      {isDoNotRenewSet && <DoNotRenewSetPanel />}
      <PendingRenewalsTable renewals={renewals} />
    </>
  )
}

export default RenewalsPanelContent
